import { memo } from "react";
import Button from "../../button";
import { useTranslate } from "../../../context/TranslationContext";

const CreatorReviewCard = ({ item, isExpanded, toggle }) => {
  const { t } = useTranslate("reviewCard");

  return (
    <div className="item" key={item._id}>
      <div className="testimonial-card d-flex flex-column gap-3">
        <div className="flex-shrink-0">
          <img
            src="../assets/images/quote.png"
            alt=""
            className="img-fluid quote-img"
          />
        </div>
        <div className="flex-grow-1">
          <p className="mb-3" style={{ textAlign: "left" }}>
            {isExpanded
              ? `${item.review_text} ${" "}`
              : `${item.review_text.slice(0, 150)}... `}
            <Button
              className="transparent-btn m-purple-text"
              text={isExpanded ? t("readLess") : t("readMore")}
              onClick={() => toggle(item._id)}
              nosite={true}
            />
          </p>
          <div className="d-flex align-items-center gap-3">
            <div className="flex-shrink-0">
              <img
                src={item?.creator_id?.picture || item?.learner_id?.picture}
                alt=""
                className="img-fluid testimonial-img"
                loading="lazy"
              />
            </div>
            <div className="flex-grow-1">
              <h5 className="text-uppercase mb-0">
                {item?.creator_id?.first_name || item?.learner_id?.first_name}{" "}
                {item?.creator_id?.last_name || item?.learner_id?.last_name}
              </h5>
              <p className="m-purple-text mb-0">
                {item?.creator_id?.role === "creator"
                  ? "Creator"
                  : item?.learner_id?.role === "learner"
                    ? "Learner"
                    : "Both"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(CreatorReviewCard);
